import { render, staticRenderFns } from "./Breaking-component.vue?vue&type=template&id=471c38b6&"
import script from "./Breaking-component.vue?vue&type=script&lang=js&"
export * from "./Breaking-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports